
        import { G as Group, B as BoxGeometry, d as Mesh, M as MeshStandardMaterial, b as Color, w as Box3, g as Vector3 } from "./assets/scene-CqtYl5hY.js";
        import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";

        (function () {
            let furnitureGroup = null;
            let customGLTFScene = null;
            const floorY = 0.6; // Top of floor tiles

            function createOutdoorLoungeSet() {
                const furniture = new Group();
                furniture.name = "furnitureGroup";
                return furniture;
            }

            let isGlbLoaded = false;
            let isGlbLoading = false;

            async function loadGLBModel(source) {
                if (isGlbLoaded || isGlbLoading) return;
                isGlbLoading = true;
                const spinner = document.getElementById("furnitureLoadingSpinner");
                if (spinner) spinner.style.display = "inline";

                console.log("[FURNITURE] Starting GLTF load from:", source);
                try {
                    const loader = new GLTFLoader();
                    const onLoad = (gltf) => {
                        isGlbLoaded = true;
                        isGlbLoading = false;
                        if (spinner) spinner.style.display = "none";
                        console.log("[FURNITURE] GLTF loaded successfully!", gltf);
                        const sceneObj = gltf.scene || gltf.scenes[0];
                        if (!sceneObj) return;

                        try {
                            const b3 = new Box3().setFromObject(sceneObj);
                            const size = new Vector3();
                            b3.getSize(size);
                            const center = new Vector3();
                            b3.getCenter(center);

                            const maxDim = Math.max(size.x, size.z);
                            const targetDim = 22.0; // Fit comfortably within pergola footprint
                            const scale = maxDim > 0 ? targetDim / maxDim : 1.0;
                            sceneObj.scale.set(scale, scale, scale);

                            // Align bottom to floorY and center horizontally
                            sceneObj.position.x = -center.x * scale;
                            sceneObj.position.z = -center.z * scale;
                            sceneObj.position.y = floorY - b3.min.y * scale;
                        } catch (e) {
                            console.error("[FURNITURE] Bounding box calculation error:", e);
                            sceneObj.position.set(0, floorY, 0);
                        }

                        sceneObj.traverse((child) => {
                            if (child.isMesh) {
                                child.castShadow = true;
                                child.receiveShadow = true;
                            }
                        });

                        customGLTFScene = sceneObj;
                        if (!furnitureGroup) {
                            furnitureGroup = new Group();
                            furnitureGroup.name = "furnitureGroup";
                        }
                        while (furnitureGroup.children.length > 0) {
                            furnitureGroup.remove(furnitureGroup.children[0]);
                        }
                        furnitureGroup.add(customGLTFScene);
                        ensureFurnitureAttached();
                    };

                    loader.load(
                        source,
                        onLoad,
                        (xhr) => {
                            if (xhr.total > 0 && spinner) {
                                const pct = Math.round((xhr.loaded / xhr.total) * 100);
                                spinner.textContent = `Loading 3D model (${pct}%)...`;
                            }
                        },
                        (err) => {
                            isGlbLoading = false;
                            if (spinner) {
                                spinner.textContent = "Failed to load 3D model";
                                setTimeout(() => { spinner.style.display = "none"; }, 3000);
                            }
                            console.error("[FURNITURE] Error loading GLB:", err);
                        }
                    );
                } catch (err) {
                    isGlbLoading = false;
                    if (spinner) spinner.style.display = "none";
                    console.error("[FURNITURE] Loader exception:", err);
                }
            }

            function ensureFurnitureAttached() {
                const scene = window.__pergolaScene;
                if (!scene) return;

                const toggle = document.getElementById("furnitureToggle");
                const isChecked = toggle ? toggle.checked : false;

                if (!furnitureGroup) {
                    furnitureGroup = createOutdoorLoungeSet();
                }

                if (!scene.getObjectByName("furnitureGroup")) {
                    scene.add(furnitureGroup);
                }

                furnitureGroup.visible = isChecked;

                const rotSlider = document.getElementById("furnitureRotation");
                if (rotSlider) {
                    furnitureGroup.rotation.y = ((parseFloat(rotSlider.value) || 0) * Math.PI) / 180;
                }
            }

            function initFurnitureUI() {
                const toggle = document.getElementById("furnitureToggle");
                const controls = document.getElementById("furnitureControls");
                const rotSlider = document.getElementById("furnitureRotation");
                const rotValue = document.getElementById("furnitureRotationValue");
                const uploadInput = document.getElementById("furnitureGlbUpload");

                if (controls && toggle) {
                    controls.style.display = toggle.checked ? "" : "none";
                }

                if (toggle) {
                    toggle.addEventListener("change", function () {
                        if (this.checked && !isGlbLoaded) {
                            loadGLBModel("assets/6uSWrMs-RmWZAnk_1nl7i.glb");
                        }
                        ensureFurnitureAttached();
                        if (controls) controls.style.display = this.checked ? "" : "none";
                    });
                }

                if (rotSlider) {
                    rotSlider.addEventListener("input", function () {
                        const deg = parseFloat(this.value) || 0;
                        if (furnitureGroup) {
                            furnitureGroup.rotation.y = (deg * Math.PI) / 180;
                        }
                        if (rotValue) rotValue.textContent = deg + "°";
                    });
                }

                // Load 3D GLB model smoothly once scene is active
                const triggerGlbLoad = () => {
                    if (toggle && toggle.checked && !isGlbLoaded && !isGlbLoading) {
                        loadGLBModel("assets/6uSWrMs-RmWZAnk_1nl7i.glb");
                    }
                };

                if (window.__pergolaScene) {
                    setTimeout(triggerGlbLoad, 100);
                } else {
                    const sceneWatcher = setInterval(() => {
                        if (window.__pergolaScene) {
                            clearInterval(sceneWatcher);
                            setTimeout(triggerGlbLoad, 150);
                        }
                    }, 80);
                }

                document.addEventListener("sliderValuesChanged", ensureFurnitureAttached);
                document.addEventListener("colorChanged", ensureFurnitureAttached);
                document.addEventListener("tabChanged", ensureFurnitureAttached);
                document.addEventListener("accordionChanged", ensureFurnitureAttached);

                const poll = setInterval(() => {
                    if (window.__pergolaScene) {
                        clearInterval(poll);
                        ensureFurnitureAttached();
                    }
                }, 100);

                // Ensure re-attached when switching pergola types
                document.querySelectorAll('input[name="pergolaType"]').forEach(r => {
                    r.addEventListener('change', () => {
                        setTimeout(ensureFurnitureAttached, 300);
                        setTimeout(ensureFurnitureAttached, 800);
                    });
                });
            }

            if (document.readyState === "loading") {
                document.addEventListener("DOMContentLoaded", initFurnitureUI);
            } else {
                initFurnitureUI();
            }
        })();
    